import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getLifeplaceLink} from '../../services/getLifeplaceLink';

export const useLifeplaceLinkQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.LIFEPLACE_LINK],
		queryFn: ({signal}) => getLifeplaceLink({signal}),
		retry: 1,
		enabled: false,
	});
